import Route from './Route';

export default Route;
